import { Store } from '@ngrx/store';
import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { Globals } from '../../../../../core/_base/crud/utils/globals.service';
import { ToeService } from '../../../../../core/toe';
import { AppState } from '../../../../../core/reducers';

@Injectable()
export class ToeRdmResolver implements Resolve<any> {
    constructor(private store: Store<AppState>,
                private global: Globals,
                private toeService: ToeService) {
    }

    resolve() {
        return this.toeService.getRdm(this.global.activeTOEId);
    }
}
